<template>
  <pt-detection-corpus-list class="pt-detection-corpus-list__withData"></pt-detection-corpus-list>
</template>

<script>
import PtDetectionCorpusList from './index'
export default {
  name: 'pt-detection-corpus-list__withData',
  components: {
    'pt-detection-corpus-list': PtDetectionCorpusList
  }
}
</script>
